// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2-Fah","Logo":"Toolbar_Logo__2sq5E","DesktopOnly":"Toolbar_DesktopOnly__3BVLP"};